import Container from "../Container";
import Banner from "../Banner";
import Button from "../Button";

export default function SectionConceptIntro({title, body, cta, titleClassName, bodyClassName, ...rest}) {

    return (
        <section className="py-16 md:py-24" {...rest}>
            <Container className="flex flex-col items-center gap-12">
                <header>
                    <Banner title={title}
                            body={body}
                            className="text-center"
                            titleClassName={titleClassName}
                            bodyClassName={bodyClassName}
                    />
                </header>

                {cta && <Button {...cta}/>}
            </Container>
        </section>
    );
}
